// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Vetting48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Vetting48Filled: FC<Vetting48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path
                d="M19.454 5.496c2.283-3.01 6.81-3.011 9.093 0A5.705 5.705 0 0 0 33.87 7.7c3.743-.515 6.944 2.686 6.43 6.43a5.705 5.705 0 0 0 2.205 5.323c3.01 2.283 3.01 6.81 0 9.093a5.705 5.705 0 0 0-2.206 5.323c.515 3.743-2.686 6.944-6.43 6.43a5.705 5.705 0 0 0-5.322 2.205c-2.284 3.01-6.81 3.01-9.093 0A5.706 5.706 0 0 0 14.13 40.3c-3.743.514-6.944-2.687-6.43-6.43a5.705 5.705 0 0 0-2.204-5.323c-3.011-2.283-3.011-6.81 0-9.093A5.705 5.705 0 0 0 7.7 14.13c-.515-3.744 2.686-6.945 6.43-6.43a5.705 5.705 0 0 0 5.323-2.205ZM21.85 26.35 17.1 21.4l-2.3 2.25 7.05 7L33.2 19.4l-2.25-2.05-9.1 9Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Vetting48Filled;
